import styled from 'styled-components';

// Filter card layout — mirrors Pages/Processes/styles.js (FilterCard/FilterCardLabel/
// FilterField/FilterFieldLabel/FilterActions), the reference list-page pattern. Buttons
// themselves are Components/ui/Button, not local styled buttons.
export const FilterCard = styled.div`
  background: white;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
  margin-bottom: 16px;
`;

export const FilterCardLabel = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: var(--vo-slate);
  margin: 0 0 16px;
  letter-spacing: .08em;
  text-transform: uppercase;
`;

export const FilterRow = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $cols = 3 }) => $cols}, 1fr);
  gap: 14px;
  margin-bottom: ${({ $last }) => ($last ? '18px' : '14px')};
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const FilterFieldLabel = styled.label`
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: var(--vo-slate);
`;

export const FilterActions = styled.div`
  display: flex;
  gap: 10px;
`;

export const FilterButtonSx = { height: '40px', padding: '0 20px' };

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;
